export function getInitialSearch(getPreference, prefKey) {
	let initialSearch = getPreference(prefKey);
	if (initialSearch) return initialSearch;
	else return '';
};

export function getInitialDataState(getPreference, prefKey, defaultState) {
	let initialDataState = getPreference(prefKey);
	if (initialDataState) return JSON.parse(initialDataState);
	else return defaultState;
};

export function getInitialColumnState(columns, getPreference, prefKey, identifier, startIndex = 1) {
	let initialColumnState = getPreference(prefKey + (identifier ? "_" + identifier : ""));
	let hiddenColumns = getHiddenColumns(getPreference, prefKey, identifier);
	if (initialColumnState) initialColumnState = syncWithAvailableColumns(JSON.parse(initialColumnState), columns, startIndex);
	else initialColumnState = columns;
	return initialColumnState.filter((column) => !hiddenColumns.includes(column.field));
};

export function getHiddenColumns(getPreference, prefKey, identifier) {
	let hiddenColumns = getPreference(prefKey + "_HIDDEN_COLUMNS" + (identifier ? "_" + identifier : ""));
	if (hiddenColumns) return JSON.parse(hiddenColumns); 
	return hiddenColumns = [];
};

export function syncWithAvailableColumns(savedColumns, allowableColumns, startIndex = 1) {
 	let allowedColumnsAsMap = getColumnArrayAsMap(allowableColumns);
	let savedColumnsAsMap = getColumnArrayAsMap(savedColumns);
	
	// filter out nonexistent columns
	let updatedSavedColumns = savedColumns.filter((column) => allowedColumnsAsMap[column["field"]]);

	// update saved columns with non-serializable column properties
	updatedSavedColumns = updatedSavedColumns.map((column) => {
		let allowedColumn = allowedColumnsAsMap[column.field];
		return ({...column, align: allowedColumn.align, cell: allowedColumn.cell });
	});
	
	// add missing columns
	updatedSavedColumns = updatedSavedColumns.concat(allowableColumns.filter((column) => !savedColumnsAsMap[column["field"]]));
	
	// update order index
	for (let i = 0; i < updatedSavedColumns.length; i++) updatedSavedColumns[i].orderIndex = (i + startIndex);
	
	return updatedSavedColumns;   
};

export function syncWithAvailableStaticAndDynamicColumns(savedColumns, staticColumns, dynamicColumns, startIndex = 1) {
	let staticMap = getColumnArrayAsMap(staticColumns);
	let dynamicMap = getColumnArrayAsMap(dynamicColumns);
	let savedMap = getColumnArrayAsMap(savedColumns);
	
	// filter out nonexistent columns
	let updatedSavedColumns = savedColumns.filter((column) => staticMap[column["field"]] || dynamicMap[column["field"]]);
	
	// update saved columns with non-serializable column properties
	updatedSavedColumns = updatedSavedColumns.map((column) => {
		let allowedColumn = staticMap[column.field];
		if (!allowedColumn) allowedColumn = dynamicMap[column.field];
		return ({...column, align: allowedColumn.align, cell: allowedColumn.cell });
	});
	
	// add missing columns
	updatedSavedColumns = updatedSavedColumns.concat(staticColumns.filter((column) => !savedMap[column["field"]]));
	
	// update order index
	for (let i = 0; i < updatedSavedColumns.length; i++) updatedSavedColumns[i].orderIndex = (i + startIndex);
	
	return updatedSavedColumns;  	
};

export function getColumnArrayAsMap(arr) {
	return arr.reduce((accumulator, column) => {
		let key = column["field"];
		accumulator[key] = column;
		return accumulator;
	}, {});
};

export function onColumnsChanged(event, setPreference, prefKey, startIndex = 1, workspaceId) {
	let eventColumns = event.columns || [];

	let resizedColumnField;
	if (typeof event.index === "number" && eventColumns[event.index]) {
		resizedColumnField = eventColumns[event.index].field;
	}

	let updatedColumns = eventColumns
		.filter((column) =>
			column.field !== "selected" &&
			column.field !== "drag"
		)
		.map((column) => {
			const updatedColumn = { ...column };

			if (resizedColumnField && column.field === resizedColumnField && event.newWidth) {
				updatedColumn.width = event.newWidth;
			}

			return updatedColumn;
		})
		.sort((a, b) => {
			const aOrder = typeof a.orderIndex === "number" ? a.orderIndex : 9999;
			const bOrder = typeof b.orderIndex === "number" ? b.orderIndex : 9999;
			return aOrder - bOrder;
		});

	for (let i = 0; i < updatedColumns.length; i++) {
		updatedColumns[i].orderIndex = i + startIndex;
	}

	setPreference(prefKey + (workspaceId ? "_" + workspaceId : ""), JSON.stringify(updatedColumns));
	return updatedColumns;
}